import { trigger, state, style, group, animate, transition } from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
    state('false', style({ opacity: 0, display: 'none' })),
    transition('0 => 1', group(
        [
            style({ display: 'block' }),
            animate('0.15s ease', style({
                opacity: 1
            }))
        ]
    )),
    transition('1 => 0', group(
        [
            animate('0.6s ease', style({
                opacity: 0
            }))
        ]
    ))
]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/fade.animation.ts